export default {
  tabs: {
    register: 'Registration',
    scan: 'Scan Settings',
    right: 'Member Benefits',
    privacy: 'Privacy Policy',
  },
  register: {
    conditions: 'Account Registration Conditions',
    phone: 'Phone',
    phoneCode: 'Phone Verification Code',
    email: 'Email',
    emailCode: 'Email Verification Code',
    saveRule: 'Please select at least one login method and its corresponding verification method',
    savePhoneVerifyRule: 'Please select a verification method for phone',
    saveEmailVerifyRule: 'Please select a verification method for email',
  },
  scan: {
    label: 'Per scan',
    countSuffix: 'times, add',
    growthSuffix: 'growth value',
    countPlaceholder: 'Enter scan count',
    valuePlaceholder: 'Enter value',
    tooltip: 'When consumers scan the system product QR code (valid scan count means the first scan belongs to that consumer), growth value will be added according to the scan count.',
    saveCountRule: 'Please enter the scan count',
    saveValueRule: 'Please enter the growth value',
  },
  agreement: {
    title: 'Member Benefits',
    viewTip: '(Users can view member benefits)',
    intro: 'Edit member agreement content. Each supported language can have its own version.',
    language: 'Language',
    addLang: 'Add Translation',
    delete: 'Delete',
    editorPlaceholder: 'Please enter content',
    saveBeforeSwitch: 'Current content has not been saved. Do you want to save it?',
  },
  rules: {
    title: 'Rules',
    intro1: '1. The privacy policy is mainly used to explain to consumers how the member center collects, uses and shares users personal information, including details on data usage, storage methods, security, etc. When users enter the member center, they need to agree to the policy before proceeding.',
    intro2: '2. If serving users from multiple countries, maintain privacy policies in different languages to ensure compliant display.',
    intro: 'Edit member rules content. Each supported language can have its own version.',
    titleField: 'Title',
    language: 'Language',
    addLang: 'Add Translation',
    delete: 'Delete',
    saveBeforeSwitch: 'Current content has not been saved. Do you want to save it?',
  },
  addI18nModal: {
    titleAgreement: 'Add Agreement',
    titleRules: 'Add Rules',
    language: 'Language',
    languagePlaceholder: 'Please select a language',
    content: 'Content',
  },
  deleteConfirm: 'This action cannot be undone. Are you sure to delete?',
};
